import { FieldValidator } from './field-validator'

export class NumericTextFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (!text) {
                resolve('')
            } else if (!this.isNumber(text)) {
                reject(`${fieldName} cannot contain letters or special characters`)
            } else {
                resolve('')
            }
        })
    }

    private isNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
}
